import React from "react";
import PropTypes from "prop-types";
import DatePicker from "antd/lib/date-picker";
import { clientConfig } from "@/services/auth";
import { Moment } from "@/components/proptypes";

const DateTimeInput = React.forwardRef(({ defaultValue, value, withMinutes, withSeconds, onSelect, className, ...props }, ref) => {
  const dateFormat = clientConfig.dateFormat || "YYYY-MM-DD";
  let timeFormat = "HH";
    if (withMinutes && withSeconds) timeFormat = "HH:mm:ss";
    else if (withMinutes) timeFormat = "HH:mm";
    const format = `${dateFormat} ${timeFormat}`;
  const additionalAttributes = {};
  if (defaultValue && defaultValue.isValid()) {
    additionalAttributes.defaultValue = defaultValue;
  }
  if (value === null || (value && value.isValid())) {
    additionalAttributes.value = value;
  }
  return (
    <DatePicker
      ref={ref}
      className={className}
      showTime
      inputReadOnly
      {...additionalAttributes}
      format={format}
      placeholder="Select Date and Time"
      onChange={onSelect}
      {...props}
    />
  );
});

DateTimeInput.propTypes = {
  defaultValue: Moment,
  value: Moment,
  withMinutes: PropTypes.bool,
  withSeconds: PropTypes.bool,
  onSelect: PropTypes.func,
  className: PropTypes.string,
};

DateTimeInput.defaultProps = {
  defaultValue: null,
  value: undefined,
  withMinutes:false,
  withSeconds: false,
  onSelect: () => {},
  className: "",
};

export default DateTimeInput;
